// extracted by mini-css-extract-plugin
export default {"section":"styles_section__CSavV","text-center":"styles_text-center__nsfVM"};